/** @jsx jsx */
import { jsx, Container, Box, Image } from 'theme-ui';
import TextFeature from 'components/text-feature';
import Img from 'gatsby-image';
import { useStaticQuery, graphql } from 'gatsby';

import shapePattern from 'assets/shape-pattern2.png';

const data = {
  subTitle: 'مهمتنا الأساسية',
  title: 'خدمة تنظيف شامل',
  description:
    `شركتنا للتنظيف المحترف لجميع خدمات التطهير والتنظيف ونقل الاثاث مع الفك والتركيب ومكافحة الحشرات والقوارض.وعزل الخزانات وكشف التسربات
    تنظيف الخزانات مع التعقيم تنظيف المسابح مع التعقيم وعزل الخزانات وللحام الخزانات صيانة مكيفات تنظيف مكيفات تنظيف مساجد بأقل الأسعار تنظيف وغسيل كنب ومجالس مع التنشيف والتعطير تنظيف وغسيل موكيت وسجاد وستاير مع التعطير ويوجد لدينا قسم خاص لعزل الخزانات والاسطح`,
  btnName: 'اتصل بنا',
  btnURL: 'tel:0550474803',
};

export default function CoreFeature() {
  // Graphql image query
  const dataThumb = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "core-feature.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 620) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <section sx={{ variant: 'section.coreFeature' }}>
      <Container sx={styles.containerBox}>
        <Box sx={styles.contentBox}>
          <TextFeature
            subTitle={data.subTitle}
            title={data.title}
            description={data.description}
            btnName={data.btnName}
            btnURL={data.btnURL}
          />
        </Box>
        <Box sx={styles.thumbnail}>
          <Img fluid={dataThumb.placeholderImage.childImageSharp.fluid} />
          <Box sx={styles.shapeBox}>
            <Image src={shapePattern} alt="Shape" />
          </Box>
        </Box>
      </Container>
    </section>
  );
}

const styles = {
  containerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: ['wrap', null, null, 'nowrap'],
    pb: [0, 7, 0, null, 7],
  },
  contentBox: {
    flexShrink: 0,
    px: [0, null, '30px', 0],
    textAlign: ['center', null, null, 'start'],
    width: ['100%', '80%', null, 340, 400, 430, null, 485],
    pb: ['50px', '60px', null, 0],
    mx: ['auto', null, null, 0],
    '.description': {
      pl: [0, null, 6, 7, 6],
    },
  },
  thumbnail: {
    display: 'inline-flex',
    position: 'relative',
    mr: 'auto',
    ml: ['auto', null, null, null, 7],
    width: [335, '100%', 620, 380, 510, 620],
    '> img': {
      position: 'relative',
      zIndex: 1,
      height: [310, 'auto'],
    },
  },
  shapeBox: {
    position: 'absolute',
    bottom: -65,
    right: -165,
    zIndex: -1,
    display: ['none', 'inline-block', 'none', null, 'inline-block'],
  },
};
